import ctaFragment from '@lib/fragments/cta-fragment';
import gql from 'graphql-tag';

const textVideoSectionFragment = gql`
  fragment textVideoSectionFields on TextVideoSection {
    title
    subtitle
    text
    cta {
      ...ctaFields
    }
    video {
      youtubeId: youtube_id
      embeddedVideo: embedded_video {
        playbackId: playback_id
      }
      alt: alt_text
      thumbnail {
        ...assetFields
        url(width: 1280, height: 720, format: "webp")
      }
    }
    textLeft: text_left
    backgroundColor: background_color {
      color
    }
  }
  ${ctaFragment}
`;

export default textVideoSectionFragment;
